module.exports={
  "sizeRepresentsValueOf": "Size represents value of",
  "maxBubbleSize": "max. bubble size",
  "bubbleSize": "Bubble size",
  "autoAdjust": "Auto-adjust",
  "notAvailable": "Not available",
  "changeColorPalette": "Change color palette",
  "visualizeAs": "Visualize as"
}
